// @core/api/endpoints/payment/get_payment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetPaymentResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Get payment by ID
 * Retrieves a payment with all attempts, provider responses, and current status.
 */
export async function GetPayment(
  id: string,
  options?: RequestOptions
): Promise<GetPaymentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payments/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetPaymentResponse>(requestPath, { ...requestOptions });
}
